"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.accordion .bx--accordion__title {\n  font-size: 16px;\n  color: #e41b13;\n  line-height: 1.25;\n  display: flex; }\n\n.accordion .bx--accordion__content {\n  padding: 8px 132px 14px 16px; }\n  .accordion .bx--accordion__content p {\n    font-size: 16px; }\n\n@media (max-width: 1055px) {\n  .accordion .bx--accordion__content {\n    padding-right: 81px; } }\n\n@media (max-width: 671px) {\n  .accordion .bx--accordion__content {\n    padding-right: 48px; } }\n";
  const fileName = "Accordion_Accordion";
  const element = document.querySelector("style[data-sass-component='Accordion_Accordion']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Accordion = props => {
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Accordion, {
    className: 'accordion'
  }, props.items.map((_ref, index) => {
    let {
      title,
      content,
      ...rest
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.AccordionItem, _extends({
      key: index,
      title: title
    }, rest), content);
  }));
};
Accordion.propTypes = {
  items: _propTypes.default.array.isRequired
};
var _default = exports.default = Accordion;